import { Typography } from "antd";
import UsersEditor from "./users-editor";
import "./companies-page.css";

const SuperAdminsPage = () => (
  <div className="companies">
    <Typography.Title level={2}>Суперадмины</Typography.Title>
    <Typography.Paragraph type="secondary">
      Пользователи без компании. Входят в кабинет и могут открыть любую компанию.
    </Typography.Paragraph>
    <UsersEditor listUrl="users/superadmins" superAdmin canEdit showAdminFlag={false} />
  </div>
);

export default SuperAdminsPage;
